import createWixData, { Environment } from '@wix/wix-data-platformized-client';
import { HttpClient } from '@wix/http-client';

import type { EditorAPI } from '#packages/editorAPI';

export const createWixCodeCollectionsAPI = (editorAPI: EditorAPI) => {
  return createWixData({
    authHeader: editorAPI.dsRead.wixCode.getClientSpec().instance,
    gridAppId: editorAPI.wixCode.fileSystem.getViewerInfo().gridAppId,
    environment: Environment.SANDBOX_PREFERRED,
    httpClient: new HttpClient(),
  });
};
